// extracted by mini-css-extract-plugin
export default {"media":"wz2cRA","imageContainer":"nObu37","seo_only":"l_Z0AS","seoOnly":"l_Z0AS","navigation":"Xq7Zhm","fadeout":"Y1EgS7","fadein":"wcu3Sj","oldNoMedia":"mo5PKG","noMedia":"T8xQVK"};